/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

import * as _polished from 'polished';

export const ARROW_DOWN = 40;
export const ARROW_LEFT = 37;
export const ARROW_RIGHT = 39;
export const ARROW_UP = 38;

export function customTheme(mode, theme) {
  switch (mode) {
    case 'dark':
      return {
        colorActiveBackground: theme.colorHpBlue4,
        colorBorderColor: theme.colorHpBlue4,
        colorHoverBackground: (0, _polished.rgba)(theme.colorHpBlue4, 0.05)
      };

    case 'contrast':
      return {
        colorActiveBackground: theme.colorHighContrastBlue,
        colorBorderColor: theme.colorWhite,
        colorHoverBackground: 'transparent'
      };

    default:
      return {
        colorActiveBackground: theme.colorHpBlue6,
        colorBorderColor: theme.colorHpBlue6,
        colorHoverBackground: (0, _polished.rgba)(theme.colorHpBlue6, 0.05)
      };
  }
}
